export enum ResponseStatusCodeConstants {
    BAD_PAYLOAD = 1,
    UNKNOWN_ERROR = 2,
    REQUIRE_CONSENT = 3,
    SUCCESS = 4,
    NO_EMAIL = 5,
    RETRY_REQUEST = 6,
    DATA_NOT_READY = 7,
    USER_NOT_EXISTS = 8,
    NO_ORGANIZATION = 9,
    NOT_ENQUEUED = 10
}
